import React from 'react';
import axios from 'axios';
import { getSession } from 'Vulture/Session';
import { broncoURL, commitHash } from 'Vulture/ENV';
import CustomIcon from '../Common/CustomIcon/CustomIcon';
import style from './ChonkyFileBrowser.module.css';

class EditFolderModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            folderName: ''
        };
        
        this.handleFolderNameChange = this.handleFolderNameChange.bind(this);
        this.handleEditFolder = this.handleEditFolder.bind(this);
    }

    handleFolderNameChange(e) {
        this.setState({ folderName: e.target.value });
    }

    async handleEditFolder() {
        const { folderName } = this.state;
        const { folder, refreshFileBrowserData, app } = this.props;

        if (!folderName.trim()) {
            alert('Please enter a folder name');
            return;
        }

        app.setState({ loading: true });
        try {
            const session = getSession();
            const headers = {
                headers: {
                    'X-Auth-Session': session.session,
                    'X-Spark-API-version': commitHash,
                    'Content-Type': 'application/json',
                },
            };

            const backendFolderId = folder.id.replace('node_', '');
            const url = `${broncoURL}/api/folder/${backendFolderId}`;

            const response = await axios.put(
                url,
                { name: folderName },
                headers
            );

            if (response.status === 200) {
                await refreshFileBrowserData();
                app.closeModal();
                this.setState({ folderName: '' });
            } else {
                throw new Error('Failed to edit folder');
            }
        } catch (err) {
            console.error('Edit folder error:', err);
            alert(`Error editing folder: ${err.response?.data?.message || err.message}`);
        } finally {
            app.setState({ loading: false });
        }
    }

    render() {
        return (
            <div className={style.chonkyModal}>
                <div className={style.formGroup}>
                    <label>
                        Name
                        <input
                            type="text"
                            value={this.state.folderName}
                            onChange={this.handleFolderNameChange}
                        />  
                    </label>
                </div>

                <button
                    onClick={this.handleEditFolder}
                    className={`button`}
                >
                    <CustomIcon icon='save' /> Save
                </button>
            </div>
        );
    }
}

export default EditFolderModal;